import devConf from './dev.conf'
import prodConf from './prod.conf'

// TODO: create constants for the diverse envs
function __getConfig () {
  console.log('TRACE-REMOVE: conf/__getConfig: process.env.VUE_APP_GLWC_ENV is: ',
    process.env.VUE_APP_GLWC_ENV)
  // if (!process.env.VUE_APP_GLWC_ENV) {
  //   process.env.VUE_APP_GLWC_ENV = 'prod'
  // }

  if (!process.env.VUE_APP_GLWC_ENV || process.env.VUE_APP_GLWC_ENV === 'prod') {
    return prodConf
  }
  return devConf
}
export default __getConfig()
